export default () => `
  {
    paths {
      login,
      logout,
      signUp,
      profile,
      orders,
    },

    currentUser {
      id
      email
      first_name
      last_name
      gender
      birthday
      newsletter_subscribed

      addresses {
        id
        gender
        firstname
        lastname
        document_number
        address1
        address2
        neighborhood
        city
        ibge_city_code
        zipcode
        phone
        state_id
        country_id
        countryData {
          name
          iso
        }
        is_default
      }
    }
  }
`
